import axios from "axios";
import { config } from "../constants";
import { authHeader } from "../helpers";

export const homeService = {
  config,
  authHeader,
  getProductsList,
  getTopTenProducts,
  getProductPartialSearch,
  getProductDetails,
  getInsutranceList,
  getInsutranceDefaultText,
  getRetailPrice,
  getDiscountPrice,
  getCityStateForZipCode,
  savedevicelocation,
  getRecentSearchList,
  signIn,
  signUp,
  logoutOut,
  passwordChange,
  getMessagesList,
  myCoupons,
  deleteCoupon,
  saveProfile,
  getProfile,
  contactUs,
  clearRecentSearches,
  verifyPasswordChange,
  getEncUserInfo,
  loginEncUser,
  verifyResendPasswordChange,
  verifyPhonenumberChange,
  verifyEmailChange,
  getContentType,
  emailChange,
  phoneChange,
  accountResendAttempt,
  loginForgotPassword,
  loginResendForgotPassword,
  loginVerifyForgotPassword,
  searchRadius,
  saveCoupon,
  getReminderTimeZones,
  getReminderDates,
  saveDoseReminder,
  saveRefillReminder,
  sendEmailMessage,
  sendTextMessage,
  shareHCPCoupon,
  getMessagesCount,
  markAsReadMessage,
  deleteMessage,
  markAllMessagesAsRead,
  deleteAllMessages,
  allowEmailNotifications,
  denyEmailNotifications,
  allowTextNotifications,
  denyTextNotifications,
  validateCouponItem,
  saveUserInsurance,
  getInsuranceDetail,
  getPlaystoreLink,
  getCommunicationPreferences,
  saveCommunicationPreferences,
  saveZipCodeToServer,
  getDoseReminderData,
  getRefillSavingsData,
  getDeviceDetails,
  getAppSettingsIdentity,
  getProductInfo,
  shareApp,
  muteAppRating,
  appRating,
  getPrescriptionProducts,
  saveFirebaseToken,
};

function handleResponse(response) {
  if (response.status !== 200) {
    if (response.status === 401) {
      return response;
    } else {
      const error = response.status;
      return Promise.reject(error);
    }
  }
  return response.data;
}

async function signIn(params) {
  const options = {
    baseURL: config.apiUrl,
    url: "/login/",
    method: "POST",
    headers: authHeader(),
    data: params,
  };

  try {
    const response = await axios(options);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    if (error.response) {
      handleResponse(error.response);
    }
    await Promise.reject(error);
  }
}

async function signUp(params) {
  const url = params.email ? `/signup/email` : `/signup/phone`;
  const options = {
    baseURL: config.apiUrl,
    url: url,
    method: "POST",
    headers: authHeader(),
    data: params.email
      ? { email: params.email }
      : { phoneNumber: params.phone },
  };

  try {
    const response = await axios(options);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    if (error.response) {
      handleResponse(error.response);
    }
    await Promise.reject(error);
  }
}

async function logoutOut() {
  const url = "/logout";
  const options = {
    baseURL: config.apiUrl,
    url: url,
    method: "GET",
    headers: authHeader(),
  };

  try {
    const response = await axios(options);
    const data = await handleResponse(response);
    sessionStorage.clear();
    window.location.reload();
    return data;
  } catch (error) {
    if (error.response) {
      handleResponse(error.response);
    }
    await Promise.reject(error);
  }
}

async function passwordChange(params) {
  const options = {
    baseURL: config.apiUrl,
    url: "/account/changepassword",
    method: "POST",
    headers: authHeader(),
    data: params,
  };

  try {
    const response = await axios(options);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    if (error.response) {
      handleResponse(error.response);
    }
    await Promise.reject(error);
  }
}

async function getProductsList() {
  const options = {
    baseURL: config.apiUrl,
    url: "/product/list",
    method: "GET",
    headers: authHeader(),
  };

  try {
    const response = await axios(options);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    if (error.response) {
      handleResponse(error.response);
    }
    await Promise.reject(error);
  }
}

async function getTopTenProducts() {
  const options = {
    baseURL: config.apiUrl,
    url: "/productsearch/top10",
    method: "GET",
    headers: authHeader(),
  };

  try {
    const response = await axios(options);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    if (error.response) {
      handleResponse(error.response);
    }
    await Promise.reject(error);
  }
}

async function getProductPartialSearch(value) {
  const options = {
    baseURL: config.apiUrl,
    url: `/product/contains/${value?.trim()}/list`,
    method: "GET",
    headers: authHeader(),
  };

  try {
    const response = await axios(options);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    return Promise.reject(error);
  }
}

async function getProductDetails(value) {
  const options = {
    baseURL: config.apiUrl,
    url: `/productdetail/list/${value}`,
    method: "GET",
    headers: authHeader(),
  };

  try {
    const response = await axios(options);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    return Promise.reject(error);
  }
}

async function getInsutranceList(value, type) {
  let url = `/insurance/contains/${value}/list`;
  if (type) {
    url = `/insurance/${
      type === "X" ? "commercial" : "government"
    }/contains/${value}/list`;
  }
  const options = {
    baseURL: config.apiUrl,
    url: url,
    method: "GET",
    headers: authHeader(),
  };

  try {
    const response = await axios(options);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    return Promise.reject(error);
  }
}

async function getInsutranceDefaultText(type) {
  const options = {
    baseURL: config.apiUrl,
    url: `/insurance/${type === "X" ? "commercial" : "government"}/default`,
    method: "GET",
    headers: authHeader(),
  };

  try {
    const response = await axios(options);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    return Promise.reject(error);
  }
}

async function getCityStateForZipCode(value) {
  const options = {
    baseURL: config.apiUrl,
    url: `/zipcode/validate/${value}`,
    method: "GET",
    headers: authHeader(),
  };

  try {
    const response = await axios(options);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    return Promise.reject(error);
  }
}

async function savedevicelocation(currentLocation) {
  const options = {
    baseURL: config.apiUrl,
    url: `/savedevicelocation/${currentLocation?.latitude}/${currentLocation?.longitude}/${currentLocation?.zipCode}`,
    method: "GET",
    headers: authHeader(),
  };

  try {
    const response = await axios(options);
    const data = await handleResponse(response);
    const res = {
      ...data,
      data: {
        zipCode: currentLocation.zipCode,
        stateName: currentLocation.stateName,
        city: currentLocation.city,
      },
    };
    return res;
  } catch (error) {
    return Promise.reject(error);
  }
}

async function getRetailPrice(data) {
  const options = {
    baseURL: config.apiUrl,
    url: `/price/retail/${data.productID}/${data.quantity || 0}/${
      data.zipCode
    }`,
    method: "GET",
    headers: authHeader(),
  };

  try {
    const response = await axios(options);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    return Promise.reject(error);
  }
}

function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

async function getDiscountPrice(data) {
  const options = {
    baseURL: config.apiUrl,
    url: `/price/cashnew/${data.productID}/${data.quantity || 0}/${
      data.zipCode
    }`,
    method: "GET",
    headers: authHeader(),
  };
  await sleep(2000);
  try {
    const response = await axios(options);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    return Promise.reject(error);
  }
}

async function getRecentSearchList() {
  const options = {
    baseURL: config.apiUrl,
    url: `/productsearch/recent`,
    method: "GET",
    headers: authHeader(),
  };

  try {
    const response = await axios(options);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    return Promise.reject(error);
  }
}

async function getMessagesList() {
  const options = {
    baseURL: config.apiUrl,
    url: "/message/list",
    method: "GET",
    headers: authHeader(),
  };

  try {
    const response = await axios(options);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    if (error.response) {
      handleResponse(error.response);
    }
    await Promise.reject(error);
  }
}

async function getMessagesCount() {
  const options = {
    baseURL: config.apiUrl,
    url: "/message/count",
    method: "GET",
    headers: authHeader(),
  };

  try {
    const response = await axios(options);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    if (error.response) {
      handleResponse(error.response);
    }
    await Promise.reject(error);
  }
}

async function myCoupons() {
  const options = {
    baseURL: config.apiUrl,
    url: "/coupon/saved/list",
    method: "GET",
    headers: authHeader(),
  };

  try {
    const response = await axios(options);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    if (error.response) {
      handleResponse(error.response);
    }
    await Promise.reject(error);
  }
}

async function deleteCoupon(saveCouponId) {
  const options = {
    baseURL: config.apiUrl,
    url: `/coupon/delete/${saveCouponId}`,
    method: "GET",
    headers: authHeader(),
  };

  try {
    const response = await axios(options);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    if (error.response) {
      handleResponse(error.response);
    }
    await Promise.reject(error);
  }
}

async function getProfile() {
  const options = {
    baseURL: config.apiUrl,
    url: "/account/",
    method: "GET",
    headers: authHeader(),
  };

  try {
    const response = await axios(options);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    if (error.response) {
      handleResponse(error.response);
    }
    await Promise.reject(error);
  }
}

async function saveProfile(params) {
  const options = {
    baseURL: config.apiUrl,
    url: "/account/save",
    method: "POST",
    headers: authHeader(),
    data: params,
  };

  try {
    const response = await axios(options);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    if (error.response) {
      handleResponse(error.response);
    }
    await Promise.reject(error);
  }
}

async function contactUs(params) {
  const options = {
    baseURL: config.apiUrl,
    url: "/settings/contactus",
    method: "POST",
    headers: authHeader(),
    data: params,
  };

  try {
    const response = await axios(options);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    if (error.response) {
      handleResponse(error.response);
    }
    await Promise.reject(error);
  }
}

async function getContentType(type) {
  const options = {
    baseURL: config.apiUrl,
    url: `/content/${type}`,
    method: "GET",
    headers: authHeader(),
  };

  try {
    const response = await axios(options);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    if (error.status) {
      handleResponse(error);
    }
    await Promise.reject(error);
  }
}

async function clearRecentSearches() {
  const options = {
    baseURL: config.apiUrl,
    url: "/productsearch/clear",
    method: "GET",
    headers: authHeader(),
  };

  try {
    const response = await axios(options);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    if (error.response) {
      handleResponse(error.response);
    }
    await Promise.reject(error);
  }
}

async function verifyResendPasswordChange(signupAttemptId) {
  const options = {
    baseURL: config.apiUrl,
    url: `/signup/resend/${signupAttemptId}`,
    method: "GET",
    headers: authHeader(),
  };

  try {
    const response = await axios(options);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    if (error.response) {
      handleResponse(error.response);
    }
    await Promise.reject(error);
  }
}

async function verifyPasswordChange(params) {
  const options = {
    baseURL: config.apiUrl,
    url: "/signup/verify",
    method: "POST",
    headers: authHeader(),
    data: {
      signupAttemptId: params.signupAttemptId,
      temporaryPassword: params.temporaryPassword,
      password: params.password,
    },
  };

  try {
    const response = await axios(options);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    if (error.response) {
      handleResponse(error.response);
    }
    await Promise.reject(error);
  }
}

async function getEncUserInfo(encUser) {
  const options = {
    baseURL: config.apiUrl,
    url: "/sso/getuserinfo",
    method: "POST",
    headers: authHeader(),
    data: {
      encUser: encUser,
      password: "",
    },
  };

  try {
    const response = await axios(options);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    if (error.response) {
      handleResponse(error.response);
    }
    await Promise.reject(error);
  }
}

async function loginEncUser(params) {
  console.log(params);

  const options = {
    baseURL: config.apiUrl,
    url: "/sso/login",
    method: "POST",
    headers: authHeader(),
    data: params,
  };
  try {
    const response = await axios(options);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    if (error.response) {
      handleResponse(error.response);
    }
    await Promise.reject(error);
  }
}

async function verifyPhonenumberChange(params) {
  const options = {
    baseURL: config.apiUrl,
    url: "/account/verify",
    method: "POST",
    headers: authHeader(),
    data: params,
  };

  try {
    const response = await axios(options);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    if (error.response) {
      handleResponse(error.response);
    }
    await Promise.reject(error);
  }
}

async function verifyEmailChange(params) {
  const options = {
    baseURL: config.apiUrl,
    url: "/account/verify",
    method: "POST",
    headers: authHeader(),
    data: params,
  };

  try {
    const response = await axios(options);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    if (error.response) {
      handleResponse(error.response);
    }
    await Promise.reject(error);
  }
}

async function emailChange(newEmail) {
  const options = {
    baseURL: config.apiUrl,
    url: `/account/email`,
    method: "POST",
    headers: authHeader(),
    data: { email: newEmail },
  };

  try {
    const response = await axios(options);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    if (error.response) {
      handleResponse(error.response);
    }
    await Promise.reject(error);
  }
}

async function phoneChange(newPhone) {
  const options = {
    baseURL: config.apiUrl,
    url: `/account/phone`,
    method: "POST",
    headers: authHeader(),
    data: { phoneNumber: newPhone },
  };

  try {
    const response = await axios(options);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    if (error.response) {
      handleResponse(error.response);
    }
    await Promise.reject(error);
  }
}

async function accountResendAttempt(attemptID) {
  const options = {
    baseURL: config.apiUrl,
    url: `/account/resend/${attemptID}`,
    method: "GET",
    headers: authHeader(),
  };

  try {
    const response = await axios(options);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    if (error.response) {
      handleResponse(error.response);
    }
    await Promise.reject(error);
  }
}

async function loginForgotPassword(params) {
  const url = params.phone
    ? `/login/forgotpassword/phone`
    : `/login/forgotpassword/email`;

  const options = {
    baseURL: config.apiUrl,
    url: url,
    method: "POST",
    headers: authHeader(),
    data: params.phone
      ? { phoneNumber: params.phone }
      : { email: params.email },
  };

  try {
    const response = await axios(options);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    if (error.response) {
      handleResponse(error.response);
    }
    await Promise.reject(error);
  }
}

async function loginResendForgotPassword(loginId) {
  const options = {
    baseURL: config.apiUrl,
    url: `/login/forgotpassword/resend/${loginId}`,
    method: "GET",
    headers: authHeader(),
  };

  try {
    const response = await axios(options);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    if (error.response) {
      handleResponse(error.response);
    }
    await Promise.reject(error);
  }
}

async function loginVerifyForgotPassword(params) {
  const options = {
    baseURL: config.apiUrl,
    url: `/forgotpassword/verify`,
    method: "POST",
    headers: authHeader(),
    data: params,
  };

  try {
    const response = await axios(options);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    if (error.response) {
      handleResponse(error.response);
    }
    await Promise.reject(error);
  }
}

async function searchRadius() {
  const options = {
    baseURL: config.apiUrl,
    url: "/account/mileradius/option/list",
    method: "GET",
    headers: authHeader(),
  };
  try {
    const response = await axios(options);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    if (error.response) {
      handleResponse(error.response);
    }
    await Promise.reject(error);
  }
}

async function saveCoupon(params) {
  const options = {
    baseURL: config.apiUrl,
    url: `/coupon/save/${params.productDetailId}/${params.quantity || 0}/${
      params.pharmacyLocationId
    }/${params.insuranceId}/${params.couponType}`,
    method: "GET",
    headers: authHeader(),
  };
  try {
    const response = await axios(options);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    if (error.response) {
      handleResponse(error.response);
    }
    await Promise.reject(error);
  }
}

async function getReminderTimeZones() {
  const options = {
    baseURL: config.apiUrl,
    url: `/reminderschedule/timezone/option/list`,
    method: "GET",
    headers: authHeader(),
  };
  try {
    const response = await axios(options);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    if (error.response) {
      handleResponse(error.response);
    }
    await Promise.reject(error);
  }
}

async function getRefillSavingsData(productDetailId) {
  const options = {
    baseURL: config.apiUrl,
    url: `/reminderschedule/refill/${productDetailId}`,
    method: "GET",
    headers: authHeader(),
  };
  try {
    const response = await axios(options);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    if (error.response) {
      handleResponse(error.response);
    }
    await Promise.reject(error);
  }
}

async function getReminderDates() {
  const options = {
    baseURL: config.apiUrl,
    url: `/reminderschedule/startdate/option/list`,
    method: "GET",
    headers: authHeader(),
  };
  try {
    const response = await axios(options);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    if (error.response) {
      handleResponse(error.response);
    }
    await Promise.reject(error);
  }
}

async function getDoseReminderData(productDetailId) {
  const options = {
    baseURL: config.apiUrl,
    url: `/reminderschedule/dose/${productDetailId}`,
    method: "GET",
    headers: authHeader(),
  };
  try {
    const response = await axios(options);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    if (error.response) {
      handleResponse(error.response);
    }
    await Promise.reject(error);
  }
}

async function saveDoseReminder(params) {
  const options = {
    baseURL: config.apiUrl,
    url: `/reminderschedule/dose/save`,
    method: "POST",
    headers: authHeader(),
    data: params,
  };
  try {
    const response = await axios(options);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    if (error.response) {
      handleResponse(error.response);
    }
    await Promise.reject(error);
  }
}

async function saveRefillReminder(params) {
  const options = {
    baseURL: config.apiUrl,
    url: `/reminderschedule/refill/save`,
    method: "POST",
    headers: authHeader(),
    data: params,
  };
  try {
    const response = await axios(options);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    if (error.response) {
      handleResponse(error.response);
    }
    await Promise.reject(error);
  }
}

async function sendEmailMessage(params) {
  const options = {
    baseURL: config.apiUrl,
    url: `/adjudicate/sendemail`,
    method: "POST",
    headers: authHeader(),
    data: params,
  };
  try {
    const response = await axios(options);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    if (error.response) {
      handleResponse(error.response);
    }
    await Promise.reject(error);
  }
}

async function sendTextMessage(params) {
  const options = {
    baseURL: config.apiUrl,
    url: `/adjudicate/sendtext`,
    method: "POST",
    headers: authHeader(),
    data: params,
  };
  try {
    const response = await axios(options);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    if (error.response) {
      handleResponse(error.response);
    }
    await Promise.reject(error);
  }
}

async function shareHCPCoupon(params) {
  var url = "/coupon/share";
  var options = {
    baseURL: config.apiUrl,
    url: url,
    method: "POST",
    headers: authHeader(),
    data: params,
  };
  if (params.productDetailId === null) {
    url = "/shareapp";
    if (params.phoneNumber !== null) {
      url += "/text";
    } else if (params.email !== null) {
      url += "/email";
    }
    options.url = url;
  }
  try {
    const response = await axios(options);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    if (error.response) {
      handleResponse(error.response);
    }
    await Promise.reject(error);
  }
}

async function markAsReadMessage(pushnotificationId) {
  const options = {
    baseURL: config.apiUrl,
    url: `/message/markasread/${pushnotificationId}`,
    method: "GET",
    headers: authHeader(),
  };
  try {
    const response = await axios(options);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    if (error.response) {
      handleResponse(error.response);
    }
    await Promise.reject(error);
  }
}

async function deleteMessage(pushnotificationId) {
  const options = {
    baseURL: config.apiUrl,
    url: `/message/markasdeleted/${pushnotificationId}`,
    method: "GET",
    headers: authHeader(),
  };
  try {
    const response = await axios(options);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    if (error.response) {
      handleResponse(error.response);
    }
    await Promise.reject(error);
  }
}

async function markAllMessagesAsRead() {
  const options = {
    baseURL: config.apiUrl,
    url: `/message/markallasread`,
    method: "GET",
    headers: authHeader(),
  };
  try {
    const response = await axios(options);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    if (error.response) {
      handleResponse(error.response);
    }
    await Promise.reject(error);
  }
}

async function deleteAllMessages() {
  const options = {
    baseURL: config.apiUrl,
    url: `/message/markallasdeleted`,
    method: "GET",
    headers: authHeader(),
  };
  try {
    const response = await axios(options);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    if (error.response) {
      handleResponse(error.response);
    }
    await Promise.reject(error);
  }
}

async function allowEmailNotifications() {
  const options = {
    baseURL: config.apiUrl,
    url: `settings/email/allow`,
    method: "GET",
    headers: authHeader(),
  };
  try {
    const response = await axios(options);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    if (error.response) {
      handleResponse(error.response);
    }
    await Promise.reject(error);
  }
}

async function denyEmailNotifications() {
  const options = {
    baseURL: config.apiUrl,
    url: `settings/email/deny`,
    method: "GET",
    headers: authHeader(),
  };
  try {
    const response = await axios(options);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    if (error.response) {
      handleResponse(error.response);
    }
    await Promise.reject(error);
  }
}

async function allowTextNotifications() {
  const options = {
    baseURL: config.apiUrl,
    url: `settings/text/allow`,
    method: "GET",
    headers: authHeader(),
  };
  try {
    const response = await axios(options);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    if (error.response) {
      handleResponse(error.response);
    }
    await Promise.reject(error);
  }
}

async function denyTextNotifications() {
  const options = {
    baseURL: config.apiUrl,
    url: `settings/text/deny`,
    method: "GET",
    headers: authHeader(),
  };
  try {
    const response = await axios(options);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    if (error.response) {
      handleResponse(error.response);
    }
    await Promise.reject(error);
  }
}

async function validateCouponItem(saveCouponId) {
  const options = {
    baseURL: config.apiUrl,
    url: `/coupon/validate/${saveCouponId}`,
    method: "GET",
    headers: authHeader(),
  };
  try {
    const response = await axios(options);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    if (error.response) {
      handleResponse(error.response);
    }
    await Promise.reject(error);
  }
}

async function saveUserInsurance(insuranceId) {
  const options = {
    baseURL: config.apiUrl,
    url: `/insurance/update/${insuranceId}`,
    method: "GET",
    headers: authHeader(),
  };
  try {
    const response = await axios(options);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    if (error.response) {
      handleResponse(error.response);
    }
    await Promise.reject(error);
  }
}

async function getInsuranceDetail(insuranceId) {
  const options = {
    baseURL: config.apiUrl,
    url: `/insurance/${insuranceId}`,
    method: "GET",
    headers: authHeader(),
  };
  try {
    const response = await axios(options);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    if (error.response) {
      handleResponse(error.response);
    }
    await Promise.reject(error);
  }
}

async function getPlaystoreLink() {
  const appCode = localStorage.getItem("appCode");
  const options = {
    baseURL: config.apiUrl,
    url: `/app/${appCode}`,
    method: "GET",
    headers: authHeader(),
  };
  try {
    const response = await axios(options);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    if (error.response) {
      handleResponse(error.response);
    }
    await Promise.reject(error);
  }
}

async function getCommunicationPreferences(encUser) {
  const options = {
    baseURL: config.apiUrl,
    url: `/app/communicationpreferences/${encUser}`,
    method: "GET",
  };
  try {
    const response = await axios(options);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    if (error.response) {
      handleResponse(error.response);
    }
    await Promise.reject(error);
  }
}

async function saveCommunicationPreferences(params) {
  const options = {
    baseURL: config.apiUrl,
    url: `/app/communicationpreferences/${params.encUser}`,
    method: "POST",
    headers: authHeader(),
    data: params.data,
  };
  try {
    const response = await axios(options);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    if (error.response) {
      handleResponse(error.response);
    }
    await Promise.reject(error);
  }
}

async function saveZipCodeToServer(zipCode) {
  const options = {
    baseURL: config.apiUrl,
    url: `/zipcode/useZipCode/${zipCode}`,
    method: "GET",
    headers: authHeader(),
  };
  try {
    const response = await axios(options);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    if (error.response) {
      handleResponse(error.response);
    }
    await Promise.reject(error);
  }
}

async function getDeviceDetails() {
  const options = {
    baseURL: config.apiUrl,
    url: `/device`,
    method: "GET",
    headers: authHeader(),
  };
  try {
    const response = await axios(options);
    sessionStorage.setItem("deviceInfo", JSON.stringify(response?.data?.data));
    return await handleResponse(response);
  } catch (error) {
    if (error.response) {
      handleResponse(error.response);
    }
    await Promise.reject(error);
  }
}

async function getAppSettingsIdentity() {
  const options = {
    baseURL: config.apiUrl,
    url: `/settings/identity`,
    method: "GET",
    headers: authHeader(),
  };
  try {
    const response = await axios(options);
    return await handleResponse(response);
  } catch (error) {
    if (error.response) {
      handleResponse(error.response);
    }
    await Promise.reject(error);
  }
}

async function shareApp(mobile, engagementId) {
  const options = {
    baseURL: config.apiUrl,
    url: `/shareapp/text/${engagementId}`,
    method: "POST",
    headers: authHeader(),
    data: { phoneNumber: mobile },
  };
  try {
    const response = await axios(options);
    return await handleResponse(response);
  } catch (error) {
    if (error.response) {
      handleResponse(error.response);
    }
    await Promise.reject(error);
  }
}

async function muteAppRating(engagementId) {
  const options = {
    baseURL: config.apiUrl,
    url: `/mute/${engagementId}`,
    method: "GET",
    headers: authHeader(),
  };
  try {
    const response = await axios(options);
    return await handleResponse(response);
  } catch (error) {
    if (error.response) {
      handleResponse(error.response);
    }
    await Promise.reject(error);
  }
}

async function appRating(rating, engagementId, feedback) {
  const options = {
    baseURL: config.apiUrl,
    url: `/saverating`,
    method: "POST",
    headers: authHeader(),
    data: {
      engagementId: engagementId,
      rating: rating,
      commentText: feedback,
    },
  };

  try {
    const response = await axios(options);
    return await handleResponse(response);
  } catch (error) {
    if (error.response) {
      handleResponse(error.response);
    }
    await Promise.reject(error);
  }
}

async function getProductInfo(productDetailId) {
  const options = {
    baseURL: config.apiUrl,
    url: `/pem/${productDetailId}`,
    method: "GET",
    headers: authHeader(),
  };
  try {
    const response = await axios(options);
    return await handleResponse(response);
  } catch (error) {
    if (error.response) {
      handleResponse(error.response);
    }
    await Promise.reject(error);
  }
}

async function getPrescriptionProducts() {
  const options = {
    baseURL: config.apiUrl,
    url: `/product/prescription`,
    method: "GET",
    headers: authHeader(),
  };
  try {
    const response = await axios(options);
    return await handleResponse(response);
  } catch (error) {
    if (error.response) {
      handleResponse(error.response);
    }
    await Promise.reject(error);
  }
}

async function saveFirebaseToken(token) {
  const options = {
    baseURL: config.apiUrl,
    url: "/savedevicetoken",
    method: "POST",
    headers: authHeader(),
    data: token,
  };

  try {
    const response = await axios(options);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    if (error.response) {
      handleResponse(error.response);
    }
    await Promise.reject(error);
  }
}



